import ApiService from '@core/api/services/ApiService';
import EcommerceService from '@core/ecommerce/services/EcommerceService';
import { formatDateISO, formatDateLong } from '@helpers/date';
import { ReactComponent as YSPlus } from '@img/icons/ys+.svg';
import { ReactComponent as YS } from '@img/icons/ys.svg';
import Button from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './DownloadCard.styles';
const DownloadCard = (props) => {
    const iconPath = props.useSpecificIconPath
        ? '/SiteFiles/next-gen/src/img/icons/pdf-file.svg'
        : props.icon;
    const handleDownload = async () => {
        const baseUrl = window?.location?.origin?.substring(0, window?.location?.origin?.length);
        if (!props.type || props.type === undefined) {
            const response = await ApiService.request({
                method: 'GET',
                baseUrl: baseUrl,
                slug: props.url
                    ? props.url
                    : EcommerceService.GetDownloadPdfUrl({ orderNumber: props.documentNumber }),
            });
            if (!response.url) {
                return;
            }
            window.open(response.url, '_blank');
            return;
        }
        window.open(baseUrl + props.url);
    };
    const renderTopRightIcon = () => {
        switch (props.iconPosition) {
            default:
            case 'bottom-right': {
                if (!iconPath) {
                    return null;
                }
                return React.createElement(S.IconBox, null, renderItemType(props.type));
            }
            case 'top-right': {
                if (!iconPath) {
                    return null;
                }
                return renderIcon(iconPath ?? '', props.title ?? '');
            }
        }
    };
    const renderBottomRightIcon = () => {
        switch (props.iconPosition) {
            default:
            case 'bottom-right': {
                return renderIcon(iconPath ?? '', props.title ?? '');
            }
            case 'top-right': {
                return null;
            }
        }
    };
    return (React.createElement(S.Container, { "data-has-tag": props.tag ? true : false },
        props.tag && React.createElement(S.Tag, null, props.tag),
        React.createElement(S.Inner, null,
            React.createElement(S.TopRow, null,
                props.date && (React.createElement(S.DateBox, null,
                    React.createElement("span", null,
                        props.translations &&
                            props.translations['customerportal.download-card.document-publish']
                            ? props.translations['customerportal.download-card.document-publish']
                            : 'Published',
                        ":"),
                    React.createElement(S.Date, { dateTime: formatDateISO(props.date) }, formatDateLong(props.date)))),
                renderTopRightIcon()),
            React.createElement(S.ContentRow, null,
                React.createElement(S.Title, null, props.title),
                !!props.description && (React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: props.description } }))),
            React.createElement(S.BaseRow, null,
                !!props.downloads && (React.createElement(S.Downloads, null,
                    props.downloads,
                    ' ',
                    props.translations &&
                        props.translations['customerportal.download-card.downloads-text']
                        ? props.translations['customerportal.download-card.downloads-text']
                        : 'Downloads')),
                React.createElement(Button, { branding: "grey", title: props.translations && props.translations['customerportal.download-card.download-btn']
                        ? props.translations['customerportal.download-card.download-btn']
                        : 'Download', onClick: handleDownload }),
                renderBottomRightIcon()))));
};
export default DownloadCard;
function renderIcon(icon, title) {
    if (!icon) {
        return null;
    }
    if (typeof icon === 'string') {
        return React.createElement(S.Icon, { as: "img", "aria-label": title, src: icon });
    }
    return React.createElement(S.Icon, { as: icon, "aria-label": title });
}
function renderItemType(type) {
    switch (type) {
        default:
            return null;
        case 'YS':
            return (React.createElement(S.ItemType, { "data-item-type": type },
                React.createElement(YS, null)));
        case 'YSP':
            return (React.createElement(S.ItemType, { "data-item-type": type },
                React.createElement(YSPlus, null)));
    }
}
